/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention, getID } from "src/libs/utilities"
import { IDelimiterEdge } from "./Edge1"

export default function Edge22 (props: IDelimiterEdge): JSX.Element {
	const [id, ] = useState<ID>( getID("edge") )
		useEffect(() => {
			addCSSClass(
				`edge-${id}`,
				`.edge-${id} {
					${
						!!props.item.position
							?
							`width: ${getCssDemention(props.item.position?.width, "calc(100% + 120px)")}!important;
							height: ${getCssDemention(props.item.position?.height, "auto")}!important;
							z-index: ${props.item.position.z }!important;
							position: absolute;
							top:0;
							transform: translateX(${getCssDemention(props.item.position?.left, "-60px")})  translateY(${getCssDemention(props.item.position.top, "0")}) rotate(${ props.item.position.rotate|| 0 }deg) scale(${props.item.position.scale || 1})!important;
							`
							:
							``
					}
					.picto {
						height: ${getCssDemention(props.item.position?.height, "auto")}!important;
					}
				}`
			)
			return () => {
				removeCSSClass(`edge-${id}`)
			}
		},[])

	const fill: any = props.item.fill || "var(--force-contast-color)" 

	return <div className={`w-100 flex-centered edge-${id}`}>
		<svg 
			version="1.1" 
			xmlns="http://www.w3.org/2000/svg" 
			xmlnsXlink="http://www.w3.org/1999/xlink" 
			x="0px" 
			y="0px" 
			viewBox="0 0 500 48.9" 
			xmlSpace="preserve"
			className={`landing-delimiter-torn picto`}
		>  
			<path  fill={fill} d="M241.9,13.2c1.5-0.1,3.1,0.3,4.8,0.8c0.4,0.1,0.9,0.3,0.9,0.8c0,0.6-0.6,0.6-1,0.6c-0.9,0.1-1.8,0.3-2.7,0.4
				c-3.1,0.3-5.5,1.8-6.9,4.4c-1.5,2.7-1,5.6,0.5,8.3c0.6,1.1,1.6,1.6,2.7,2c2.5,0.8,4.9,0.6,7.2-0.7c1-0.6,1.5-1.5,1.6-2.6
				c0-1-0.2-1.9-1.1-2.5c-0.8-0.5-1.6,0-2.3,0.4c-1,0.6-1.9,1.2-2.9,1.8c-0.9,0.5-1.8,0.8-2.7,0c-0.9-0.8-1.2-1.8-1.1-3
				c0.1-0.5,0.2-1,0.6-1.4c2-2.8,4.9-4.2,8.3-4c3.5,0.2,5.4,2.6,6.4,5.7c0.4,1.1,0.5,2.3,0.5,3.5c0,2.8-1.1,5.1-3.6,6.6
				c-4.3,2.7-9,3.3-13.8,1.7c-6-1.9-8.9-7.7-7.3-13.9C231.7,16.5,235.9,13.2,241.9,13.2z"/>
			<path  fill={fill} d="M226.4,5c1.4,0.1,2.7,0.9,4,1.8c1.3,0.8,2.2,2,2.9,3.4c0.4,0.8,0.5,1.6-0.2,2.3c-0.7,0.7-1.4,0.6-2.2,0.1
				c-2.1-1.3-3.9-2.9-5.5-4.9c-0.5-0.6-0.8-1.3-0.4-2.1C225.2,5.1,225.6,5,226.4,5z"/>
			<path  fill={fill} d="M249,10.2c0.7-3.1,2.3-5.7,5.1-7.4c0.5-0.3,1.1-0.4,1.6,0.1c0.5,0.4,0.4,1.1,0.2,1.5c-1.1,2.7-2.7,5-4.9,7
				c-0.4,0.3-0.9,0.6-1.4,0.3C249,11.4,249,10.8,249,10.2z"/>
			<path  fill={fill} d="M253.9,36.6c1.2-0.1,2,0.7,2.9,1.3c1.6,1.2,2.8,2.7,3.4,4.6c0.2,0.6,0.1,1.2-0.3,1.6c-0.5,0.4-1,0.1-1.4-0.2
				c-2.2-1.3-4.2-3-5.6-5.2c-0.3-0.4-0.6-1-0.3-1.5C252.7,36.7,253.3,36.6,253.9,36.6z"/>
			<path  fill={fill} d="M230.1,44.9c0.3-2.9,1.2-5.4,3.2-7.3c1.1-1,1.8-0.8,2.2,0.6c0.2,0.7,0.3,1.5,0,2.2c-0.9,1.8-2.1,3.5-3.6,4.8
				c-0.1,0.1-0.3,0.2-0.5,0.3c-0.3,0.2-0.7,0.3-1,0.1C230.1,45.5,230,45.2,230.1,44.9z"/>
			<path  fill={fill} d="M257.7,19.2c-0.7-0.1-1.1-0.2-1.3-0.6c-0.2-0.5,0-0.9,0.3-1.2c1.9-1.7,4-3.3,6.5-3.9c0.6-0.2,1.1,0,1.4,0.5
				c0.4,0.7,0.2,1.5-0.3,2C262.2,17.6,259.8,18.3,257.7,19.2z"/>
			<path  fill={fill} d="M244.3,43.8c0.1-1.2-0.2-2.5,0.4-3.8c0.2-0.4,0.4-0.9,1-0.9c0.5,0,0.7,0.4,0.9,0.9c0.6,1.7,0.7,3.4,0.5,5.1
				c-0.1,0.9,0,1.8-0.4,2.7c-0.2,0.5-0.5,1.1-1.1,1.1c-0.7,0-0.8-0.7-1-1.2C244.2,46.4,244.4,45.1,244.3,43.8z"/>
			<path  fill={fill} d="M221.8,17.3c1.8,0,3.3,0.1,4.8,0.7c1.1,0.5,1.3,1.3,0.5,1.9c-0.2,0.2-0.4,0.2-0.7,0.2c-2.5-0.3-5.1-0.4-7.5-1.1
				c-0.6-0.2-1.5-0.2-1.4-1c0.1-0.7,1-0.6,1.6-0.7C220.1,17.2,221,17.1,221.8,17.3z"/>
			<path  fill={fill} d="M241.9,7.4c0,0.7,0,1.3-0.2,2c-0.1,0.4-0.3,0.7-0.7,0.7c-0.4,0.1-0.6-0.2-0.9-0.5c-0.8-1-0.8-2.3-1-3.5
				c-0.2-1-0.3-2-0.3-3.1c-0.1-0.8,0.3-1.4,1.1-1.6c0.9-0.2,1.1,0.6,1.3,1.2C241.8,4.1,241.8,5.8,241.9,7.4z"/>
			<path  fill={fill} d="M260.9,27.6c1.4,0,2.6,0,3.7,0.4c0.8,0.3,1.2,0.9,1.1,1.7c-0.1,0.9-0.8,1.1-1.4,1.1c-2.2,0-4.3-0.6-6.2-1.7
				c-0.3-0.2-0.6-0.4-0.5-0.7c0-0.4,0.4-0.5,0.8-0.6C259.2,27.4,260.2,27.6,260.9,27.6z"/>
			<path  fill={fill} d="M219.3,33.5c-0.2,0-0.5,0-0.7,0c-0.2,0-0.5-0.1-0.6-0.3c-0.2-0.3,0.1-0.5,0.3-0.7c0.7-0.6,1.5-1.1,2.3-1.4
				c1.9-0.8,3.8-1.7,6-1.4c0.4,0,0.8,0,0.9,0.4c0.1,0.5-0.3,0.7-0.6,0.9C224.6,32.4,222,33.1,219.3,33.5z"/> 
			<path  fill={fill} d="M279.1,28.4c-1.1-0.2-2.2-0.3-2.1-1.8c0.1-1.4,0.9-2.3,2.4-2.3c1.3,0,2.1,1,2.2,2.2C281.6,28.2,280.2,28.2,279.1,28.4z"/>
			<path  fill={fill} d="M296,32.2c0.2-1.4,0.8-2.8,2.8-3c1.9-0.1,3.6,2,3.5,4.3c0,1.7-0.8,2.7-2.5,2.7C297.7,36.3,296,34.6,296,32.2z"/>
			<path  fill={fill} d="M181.3,25.5c0.1-1.1,0.6-2.2,2.2-2.3c1.5-0.1,2.8,1.6,2.8,3.4c0,1.3-0.6,2.1-2,2.1C182.6,28.7,181.3,27.4,181.3,25.5z"/>
			<path  fill={fill} d="M204.4,32.3c0.1-1.1,0.6-2.2,2.2-2.3c1.5-0.1,2.8,1.6,2.8,3.4c0,1.3-0.6,2.1-2,2.1C205.7,35.5,204.4,34.2,204.4,32.3z"/>
			<path  fill={fill} d="M292.2,22.3c-0.1,1.7-1.3,2.9-3.1,3.2c-1.5,0.2-3-2.2-2.9-4.5c0.1-1.4,0.7-2.3,2.2-2.3C290.4,18.6,292.2,20.3,292.2,22.3z"/>
			<path  fill={fill} d="M197.2,22.8c-0.1,1.4-1.1,2.4-2.6,2.7c-1.3,0.2-2.5-1.8-2.4-3.8c0.1-1.2,0.6-1.9,1.9-2C195.7,19.8,197.3,21.1,197.2,22.8z"/>
		</svg>
	</div>
}

